export const setApps = apps => ({
    type: 'setApps',
    payload: apps,
})
